/* eslint-disable import/no-cycle */
import { useEffect } from "react";
import { createMachine, interpret } from "xstate";
import { APP_SM, APP_SM_CONST } from "../machines/AppSM";
import ThreejsScene from "../modules/ThreejsScene";
import ConfigLoader from "../modules/ConfigLoader";
import AssetLoader from "../modules/AssetLoader";
import ARPlatform from "../modules/ARPlatform";
import ARModels from "../modules/ARModels";
import MainStateStore from "../modules/MainStateStore";
import touchEvents from "../modules/touchEvents";
import SKUInstanceConfigs from "../modules/SKUInstanceConfigs";
// import Tracker from "../modules/Tracker";
import CommonTracker from "../modules/CommonTracker";
import WebXR from "../modules/WebXR";
import EighthWall from "../modules/EighthWall";
import PositionReticle from "../modules/PositionReticle";
import { useButtonConfigStore } from "../pages/Frontend";
import { ARControllerUIState } from "./ARControllerUI";
import { RendererState } from "../pages/Renderer";
import { useListnerStore } from "../App";
import { ARPageState } from "../pages/ARPage";
import { XRPageState } from "../pages/XRPage";
import { ConfiguratorState } from "./Configurator";
import Listeners from "../modules/Listeners";
import Event from "../modules/Event";
import useAppStore from "../AppStore";
import ConfigBuilder from "../modules/ConfigBuilder";
import { useSubmenuStore } from "./Submenu";
import { useEngineStore } from "./engine/store/engineStore";
import { InfoPromptState } from "./InfoPrompt";
// import { getParamsFromURL } from "../modules/MachineUtils";

const SMController = () => {
  useEffect(() => {
    const config = APP_SM({
      // Actions
      centerAndScale: () => {},
      ThreejsScene,
      ConfigLoader,
      ARPlatform,
      AssetLoader,
      ARModels,
      MainStateStore,
      touchEvents,
      SKUInstanceConfigs,
      WebXR,
      EighthWall,
      Listeners,
      Tracker: CommonTracker,
      window, // this is being done, so that we can run visualizer on the laptop
      useButtonConfigStore,
      PositionReticle,
      ARControllerUIState,
      RendererState,
      ARPageState,
      XRPageState,
      InfoPromptState,
      useAppStore,
      useListnerStore,
      ConfiguratorState,
      ConfigBuilder,
      Event,
      useSubmenuStore,
      useEngineStore,
    });
    // console.log("State Machine config", JSON.stringify(config, null, 2));
    const machine = createMachine(config);
    if (machine != null) {
      const service = interpret(machine);
      service.subscribe((state) =>
        console.log("StateMachine service subs", state.value, state.event)
      );
      // service.onTransition((state) => {
      //   const mode = Number(getParamsFromURL(window, "ar")) === 0 ? "XR" : "AR";
      //   if (state.changed) {
      //     let eventLabel = "";
      //     if (typeof state.value.RENDERER === "object") {
      //       if (typeof state.value.RENDERER[mode] === "object") {
      //         Object.keys(state.value.RENDERER[mode]).forEach((eventName) => {
      //           if (typeof state.value.RENDERER[mode][eventName] === "object") {
      //             Object.keys(state.value.RENDERER[mode][eventName]).forEach(
      //               (ename) => {
      //                 eventLabel = ename;
      //               }
      //             );
      //           } else {
      //             eventLabel = `${eventName}->${state.value.RENDERER[mode][eventName]}`;
      //           }
      //         });
      //       } else {
      //         eventLabel = state.value.RENDERER[mode];
      //       }
      //     }
      //     if (eventLabel && eventLabel !== "") {
      //       Tracker.sendToGa(
      //         "",
      //         "",
      //         "Application State Change",
      //         `State Changed To ${eventLabel}`,
      //         true
      //       );
      //     }
      //   }
      // });
      const sendSMEvent = (event, metadata) => {
        // console.log("StateMachine send event", event, metadata);
        service.send({ type: event, metadata });
      };
      Event.subscribe(APP_SM_CONST.ID, sendSMEvent);
      service.start();
    }
  }, []);

  return null;
};

export default SMController;
